/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import Pagination from '../../../../features/Pagination/Pagination';
import { GetDate, GetTime } from '../../../../utils/Show';
import { mkRelativeUrl } from '../../../../utils/URL';
import cn from '../../../../utils/cn';

function TableRow({ item }) {
    const navigate = useNavigate();
    // const { setConfirm, setMessage } = useTemplate();
    // const handleDeleteModalShow = (id) => {
    //     setConfirm({
    //         text: 'Are you sure you want to delete this log?',
    //         textAction: 'Yes, Delete',
    //         clickAction: () => {
    //             ApiExternalLogsDelete(id)
    //                 .then(({ title }) => {
    //                     setMessage({ type: 'success', text: title });
    //                     setConfirm(null);
    //                     handleReload();
    //                 })
    //                 .catch((err) => {
    //                     setMessage({ type: 'error', text: err.toString(0) });
    //                 });
    //         }
    //     });
    // };
    return (
        <tr className={cn(`group hover:!bg-secondary-50`, { 'placeholder-mode': item?.demo })}>
            <td className="!pl-5">
                <span>{item?.id}</span>
            </td>
            <td
                className={cn(
                    `text-center hover:underline group-hover:font-medium group-hover:text-secondary cursor-pointer `
                )}
            >
                <span
                    onClick={() =>
                        navigate(
                            mkRelativeUrl(`/subscriptions/manage/${item?.subscriptionId}/info`)
                        )
                    }
                >
                    {item?.subscriptionId}
                </span>
            </td>
            <td className="text-center hover:underline group-hover:font-medium group-hover:text-secondary cursor-pointer ">
                <span
                    onClick={() => {
                        window.open(`https://ipinfo.io/${item?.ip}`);
                    }}
                >
                    {item?.ip}
                </span>
            </td>
            <td>
                <span>{item?.userAgent}</span>
            </td>
            <td className="text-center">
                <span>{item?.country}</span>
            </td>
            <td className="text-center">
                <div className="flex flex-col">
                    <span>{GetDate(item?.timeLogged)}</span>
                    <span className="text-xs">{GetTime(item?.timeLogged)}</span>
                </div>
            </td>
            <td className="text-center">
                <div className="flex flex-col">
                    <span>{GetDate(item?.timeCreated)}</span>
                    <span className="text-xs">{GetTime(item?.timeCreated)}</span>
                </div>
            </td>
            {/* <td className="text-center">
                <span
                    className={`capitalize ${item?.status === 'active' ? 'text-success' : 'text-error'}`}
                >
                    {item?.status}
                </span>
            </td> */}
        </tr>
    );
}
function TableHeader() {
    return (
        <thead>
            <tr>
                <th scope="col" className="!w-12.5">
                    <span>ID</span>
                </th>
                <th scope="col" className="w-20 text-center">
                    <span>Subscription ID</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span>IP Info.</span>
                </th>
                <th scope="col" className="w-48">
                    <span>User Agent</span>
                </th>
                <th scope="col" className="w-24 text-center">
                    <span>Country</span>
                </th>
                <th scope="col" className="w-24 text-center">
                    <span>Logged Date & Time</span>
                </th>
                <th scope="col" className="!w-24 text-center">
                    <span>Created Date & Time</span>
                </th>
                {/* <th scope="col" className="!w-20 text-center">
                    <span>Status</span>
                </th> */}
                {/* <th scope="col" className="!w-12.5">
                    <span>Action</span>
                </th> */}
            </tr>
        </thead>
    );
}

function ExternalLogsPageTable({ data, handleReload, onChangePage, pagination }) {
    return (
        <div className="external_logs_page_table mb-52 overflow-x-auto">
            <table className="bik-table" cellPadding={0} cellSpacing={0}>
                <TableHeader />
                <tbody>
                    {data && data?.length === 0 ? (
                        <tr className="border-b border-[#1B1B1F]/10 h-12.5">
                            <td colSpan={4} className="!text-left">
                                <span className="text-primary-700 ">No Logs Found!</span>
                            </td>
                        </tr>
                    ) : (
                        data?.map((item) => (
                            <TableRow key={item?.id} item={item} handleReload={handleReload} />
                        ))
                    )}
                </tbody>
            </table>
            <Pagination data={pagination} onChangePage={onChangePage} />
        </div>
    );
}

export default ExternalLogsPageTable;
